import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import PermissionDescription from './PermissionDescription';
import memoize from 'memoizee';
import { createIamAPI } from './API';
import env from '../misc/env';
var PermissionStore = /*#__PURE__*/function (_Store) {
  function PermissionStore() {
    var _this;
    _classCallCheck(this, PermissionStore);
    _this = _callSuper(this, PermissionStore, arguments);
    _this.permissions = _this.collection({
      model: PermissionDescription
    });
    _this.find = memoize(_this.find.bind(_this), {
      promise: true,
      length: 0
    });
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.rootStore.sessionStore.onWorkspaceSelected(function () {
      return _this.find();
    });
    return _this;
  }
  _inherits(PermissionStore, _Store);
  return _createClass(PermissionStore, [{
    key: "find",
    value: function () {
      var _find = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.permissions.find().then(function (perms) {
                return perms.filter(function (x) {
                  return _this2.isFeatureEnabledForPermission(x.id);
                });
              }).then(this.permissions.set));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function find() {
        return _find.apply(this, arguments);
      }
      return find;
    }()
    /**
     * Checks permission IDs against enabled workspace features.
     * For example, if coupons are disabled, then all coupon permissions
     * are technically "deny" and we don't want the user to see them either.
     * Used by `Member.hasPermission`.
     *
     * @param {*} id
     */
  }, {
    key: "isFeatureEnabledForPermission",
    value: function isFeatureEnabledForPermission(id) {
      var features = this.rootStore.sessionStore.workspace.features;
      if (id.includes('COUPON')) {
        return features.billing.couponsEnabled;
      }
      if (id.includes('ANALYTICS')) {
        return features.analyticsConfig.enabled;
      }
      if (id.includes('IMPERSONATE')) {
        return features.impersonation.enabled;
      }

      // hide all team perms just for user confusion
      /*
      if (id.includes('TEAM_') || id.includes('GROUP')) {
        return true
      }
      */

      return true;
    }
  }]);
}(Store);
export { PermissionStore as default };
//# sourceMappingURL=PermissionStore.js.map
